import React from "react";
import FloatingField from "./FloatingField";
import useFormPost from "./useFormPost";
import "./FormCard.css";

const VOLUNTEER_EMAIL = "volunteer@bugandfrog.org";

export const CRAFT_OPTIONS = ["Knitting", "Crochet", "Sewing", "Quilting", "Other crafts", "I'm new to crafting"];

// Busy Bees sign-up. Sent to /api/volunteer, which emails volunteer@.
export default function VolunteerForm() {
  const { values, status, handleChange, toggle, handleSubmit } = useFormPost("/api/volunteer", {
    name: "",
    email: "",
    phone: "",
    crafts: [],
    message: ""
  });
  const submitting = status === "submitting";

  return (
    <form className="form-card" onSubmit={handleSubmit} aria-label="Join Busy Bees">
      <FloatingField
        id="volunteer-name"
        label="Name"
        type="text"
        name="name"
        value={values.name}
        onChange={handleChange}
        placeholder="Your full name"
        autoComplete="name"
        required
      />

      <FloatingField
        id="volunteer-email"
        label="Email"
        type="email"
        name="email"
        value={values.email}
        onChange={handleChange}
        placeholder="So we can reply to you"
        autoComplete="email"
        required
      />

      <FloatingField
        id="volunteer-phone"
        label="Phone (optional)"
        type="tel"
        name="phone"
        value={values.phone}
        onChange={handleChange}
        autoComplete="tel"
      />

      <fieldset>
        <legend>What do you like to make? (optional)</legend>
        <div className="checkbox-grid">
          {CRAFT_OPTIONS.map((option) => (
            <label key={option} className="check-option">
              <input
                type="checkbox"
                checked={values.crafts.includes(option)}
                onChange={() => toggle("crafts", option)}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
      </fieldset>

      <FloatingField
        id="volunteer-message"
        label="Anything else we should know? (optional)"
        multiline
        name="message"
        value={values.message}
        onChange={handleChange}
        placeholder="Your availability, questions, favorite things to make…"
      />

      <button type="submit" className="btn" disabled={submitting}>
        {submitting ? "Sending…" : "Join Busy Bees"}
      </button>

      {status === "sent" && (
        <p className="form-success" role="status">
          Thank you for joining the hive! We'll email you soon about next steps.
        </p>
      )}

      {status === "failed" && (
        <p className="form-error" role="alert">
          Something went wrong and your sign-up didn't send. Please try again, or email us at{" "}
          <a href={`mailto:${VOLUNTEER_EMAIL}`}>{VOLUNTEER_EMAIL}</a>.
        </p>
      )}
    </form>
  );
}
